export default {
	locales: [
		{ name: 'Magyar', code: 'hu' },
		{ name: 'English', code: 'en' },
		{ name: 'Deutsch', code: 'de' },
	],
	defaultLocale: 'hu',
};